import type { AccountSourceType } from 'owa-account-source-list-types';
import type { AutomappedMailbox } from './AutomappedMailbox';
import type { AccountAuthType } from './AccountAuthType';

export const CoprincipalAccount_Version1 = 1;

export interface CoprincipalAccount {
    uuid: string;
    version: number;
    accountType: AccountSourceType;
    accountAuthType?: AccountAuthType;
    emailAddress: string;
    userIdentity: string;
    routingHint?: string;
    aliases: string[];
    isEasidOverrideEmailAddress?: boolean;
    isAnotherMailbox?: boolean;
    localAuthId?: string;
    accountDescription?: string;
    hiddenAutomappedMailboxes?: AutomappedMailbox[];
    // When a core attribute of an account is changed, such as the authentication type,
    replacesAccountUuid?: string;
    // Identifies whether the account requires cloud-aware request routing
    requireCloudAwareRouting?: boolean;
}
